import backend, {WORKFLOW_ENGINE_API} from 'utils/backend/server/api_library';

import queryString from 'query-string';

const queryResourceTasks = async (filters, sort, lastEvaluatedKey) => {
  const queryParam = {
    lastEvaluatedKey,
  };

  if (filters) {
    queryParam.filters = JSON.stringify(filters);
  }

  if (sort) {
    queryParam.sort = JSON.stringify(sort);
  }

  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});
  const url = `${WORKFLOW_ENGINE_API}/task_list/resource?${query}`;
  return backend.get(url);
};

const queryCompanyTasks = async (filters, sort, lastEvaluatedKey) => {
  const queryParam = {
    lastEvaluatedKey,
  };

  if (filters) {
    queryParam.filters = JSON.stringify(filters);
  }

  if (sort) {
    queryParam.sort = JSON.stringify(sort);
  }

  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});
  const url = `${WORKFLOW_ENGINE_API}/task_list/company?${query}`;
  return backend.get(url);
};

const addTask = (body) => {
  const url = `${WORKFLOW_ENGINE_API}/task_list`;
  return backend.post(url, body);
};

const updateTask = (taskRn, body) => {
  const url = `${WORKFLOW_ENGINE_API}/task_list/update/${taskRn}`;
  return backend.put(url, body);
};

const removeTask = (taskRn) => {
  const url = `${WORKFLOW_ENGINE_API}/task_list/update/${taskRn}/status`;
  const body = {status: 'DELETED'};
  return backend.put(url, body);
};

const updateTaskStatus = (taskRn, newStatus) => {
  const url = `${WORKFLOW_ENGINE_API}/task_list/update/${taskRn}/status`;
  const body = {status: newStatus};
  return backend.put(url, body);
};

export default {
  addTask,
  queryCompanyTasks,
  queryResourceTasks,
  removeTask,
  updateTask,
  updateTaskStatus,
};
